import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './LinkNotification.module.css';

import SimpleBar from 'simplebar-react';
import useSimpleBar from '../../../../hooks/useSimpleBar';
import toast from 'react-hot-toast';

import { useAppSelector } from '../../../../hooks/useRedux';
import { selectShareLinks } from '../../../../features/shareSlice';
import { useAddSharedLinkNotiMutation } from '../../../../services/share';

import Item from '../Item';
import { SharedLink } from '../../../../types/modal';
import {
  CONTENT,
  DATE,
  RECEIVED_NEW_SHARED_LINK,
  REGISTERED_SHARED_LIBRARY,
  REGISTRATION,
} from '../../../../constants';
import { formatDate } from '../../../../utils/date';

export default function LinkNotification() {
  const cx = classNames.bind(styles);
  const [simplebarRef] = useSimpleBar();
  const links = useAppSelector(selectShareLinks);
  const linkLen = links?.length;

  const [addSharedLinkNoti] = useAddSharedLinkNotiMutation();
  const [linkList, setLinkList] = useState(links);

  const registLink = async (projectId: number) => {
    try {
      const list = await addSharedLinkNoti(projectId).unwrap();
      setLinkList(list);
      toast(REGISTERED_SHARED_LIBRARY);
    } catch (error) {
      console.error('Failed to add SharedLinkNoti', error);
    }
  };

  const isDisabled = (projectId: number) => {
    return !linkList?.find((list: SharedLink) => list.projectId === projectId);
  };

  if (!linkLen) return null;

  return (
    <>
      <div className={cx('count_msg')}>
        <span
          dangerouslySetInnerHTML={{
            __html: RECEIVED_NEW_SHARED_LINK.replace('{N}', linkLen),
          }}
        ></span>
      </div>
      <Item id="linkNotification">
        <div className={cx('panel_row', 'column')}>
          <div className={cx('table_list', 'table_head', 'notice_head')}>
            <span>{DATE}</span>
            <span>{CONTENT}</span>
            <span>{REGISTRATION}</span>
          </div>
          <SimpleBar forceVisible={true} ref={simplebarRef}>
            <div className={cx('table_list', 'table_body', 'notice_body')}>
              {links.map(({ projectId, shareDate, msg }: SharedLink) => (
                <span key={projectId} className={cx('items')}>
                  <span>{formatDate(shareDate)}</span>
                  <span className={cx('text_clip')}>{msg}</span>
                  <span>
                    <span
                      role="button"
                      className={cx('btn', 'skyt', 'share_register', {
                        'is--disabled': isDisabled(projectId),
                      })}
                      onClick={() => registLink(projectId)}
                    >
                      {REGISTRATION}
                    </span>
                  </span>
                </span>
              ))}
            </div>
          </SimpleBar>
        </div>
      </Item>
    </>
  );
}
